import "./footer.css"

import { Context } from "../../../models/context";
import { Util } from '../../../utils/util';
import { DataLayerService } from '../../../services/data-layer-service';
import { PlatformType } from "../../../types/enums";

/**
 * Handles dynamic loading and rendering of the HTML footer from a remote source.
 */
export class Footer {
    private readonly _context: Context;
    private readonly _dataLayer: DataLayerService;
    private readonly _footer: HTMLElement | null;

    /**
     * Creates an instance of the Footer class.
     * @param {Context} context - The application context used to retrieve configuration values.
     */
    public constructor(context: Context, dataLayer: DataLayerService) {
        this._context = context;
        this._dataLayer = dataLayer;
        this._footer = document.getElementById("div_footer_include");
    }

    /**
     * Initializes the footer by asynchronously fetching and injecting HTML content
     * from a configured public storage URL. Adds a timestamp query param to avoid caching.
     * @returns {Promise<void>} A promise that resolves when the footer is loaded or skipped.
     * this has been updated to server side rendering
     */
    public async init(): Promise<void> {
        if (!this._footer)
            return;
        try {
            //const response = await fetch(url);
            //if (!response.ok)
            //    return;

            //const html = await response.text();
            //this._footer.innerHTML = html;
            this._setEventListeners();
        } catch { }

        const footerElement = document.getElementsByTagName("footer")[0];
        if (!Util.isAppView()) {
            Util.showElement(footerElement);
        } else {
            Util.hideElement(footerElement);
        }
    }

    private _setEventListeners(): void {
        if (!this._footer)
            return;

        const footerLinks = Array.from(this._footer.querySelectorAll("a")) as HTMLAnchorElement[];
        if (footerLinks) {
            for (const footerLink of footerLinks) {
                //search for App download links
                if (footerLink.hostname.includes("play.google.com")){
                    Util.setElement("onclick", footerLink, () => {
                        if (this._dataLayer)
                            this._dataLayer.app_download(footerLink.innerText, footerLink.href, footerLink.hostname, PlatformType.ANDROID);
                    })
                }
                if (footerLink.hostname.includes("itunes.apple.com")) {
                    Util.setElement("onclick", footerLink, () => {
                        if (this._dataLayer)
                            this._dataLayer.app_download(footerLink.innerText, footerLink.href, footerLink.hostname, PlatformType.IOS);
                    })
                }
            }
        }
    }
}